export default __webpack_public_path__ + "static/related-people-and-groups-dark-mode-9c4ec31ad20a475b95de7d14a6db4b1f.png";